import { render } from "./AgendaItemContextMenu.vue?vue&type=template&id=99b5d680&scoped=true"
import script from "./AgendaItemContextMenu.vue?vue&type=script&lang=js"
export * from "./AgendaItemContextMenu.vue?vue&type=script&lang=js"

import "./AgendaItemContextMenu.vue?vue&type=style&index=0&id=99b5d680&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99b5d680"]])

export default __exports__